import {GetSentToastNotificationApiResponse} from '../types';

export type AppSyncAuthHeader = {
  Authorization: string;
  host: string;
};

export type AppSyncStartPayload = {
  data: string;
  extensions: {
    authorization: AppSyncAuthHeader;
  };
};

export type SubscribeToNotificationsApiArg = {
  variant: 'toast' | 'background';
} & GetSentToastNotificationApiResponse;

export type AppSyncDataPayload = {
  data: {
    onSendNotification: {
      id: string;
      tenantId: string;
      userId: string;
      backgroundNotificationId: string | null;
      toastNotificationId: string | null;
    };
  };
};
export interface AppSyncErrorPayload {
  errors: Array<{
    message: string;
    errorType?: string;
    errorCode?: number;
  }>;
}

export type AppSyncConnectionAckPayload = {
  connectionTimeoutMs: number;
};

export type AppSyncMessage = {
  id: string;
} & (
  | {
      type: 'connection_init';
    }
  | {
      type: 'connection_ack';
      payload: AppSyncConnectionAckPayload;
    }
  | {
      type: 'start';
      payload: AppSyncStartPayload;
    }
  | {
      type: 'data';
      payload: AppSyncDataPayload;
    }
  | {
      type: 'error';
      payload: AppSyncErrorPayload;
    }
  | {
      type: 'connection_error';
      payload: AppSyncErrorPayload;
    }
  | {
      type: 'complete';
    }
  | {
      type: 'ka';
    }
  | {
      type: 'stop';
    }
  | {
      type: 'start_ack';
    }
);
export type AppSyncMessageType = AppSyncMessage['type'];

/**
 * Outcome of validating `APPSYNC_URL`. `notConfigured` and `malformed` are
 * deterministic environment faults — a retry can never turn them into
 * `resolved`.
 */
export type AppSyncHostResolution =
  | {status: 'resolved'; host: string; appSyncUrl: string}
  | {status: 'notConfigured'}
  | {status: 'malformed'};

/**
 * Outcome of building the realtime WebSocket URL. The status tells the caller
 * whether another attempt makes sense:
 *   - `unauthenticated`: no access token yet — a later attempt can succeed.
 *   - `misconfigured`: `APPSYNC_URL` is missing or malformed — every later
 *     attempt fails identically, so the reconnect loop must stop.
 */
export type AppSyncWebSocketUrlResult =
  | {status: 'ready'; url: string}
  | {status: 'unauthenticated'}
  | {status: 'misconfigured'; reason: string};
